import { useEffect, useState } from 'react';
import { useUIStore } from '@/state/store';
import { ONBOARDING } from '@/data/onboarding';

export function OnboardingModal() {
  const open = useUIStore((s) => s.onboardingOpen);
  const openOnboarding = useUIStore((s) => s.openOnboarding);
  const closeOnboarding = useUIStore((s) => s.closeOnboarding);
  const openHelp = useUIStore((s) => s.openHelp);
  const openSettings = useUIStore((s) => s.openSettings);
  const setStatus = useUIStore((s) => s.setStatus);
  const [idx, setIdx] = useState(0);

  // Erst-Login-Gating: einmalig automatisch zeigen.
  useEffect(() => {
    try { if (!localStorage.getItem(ONBOARDING.seenFlag)) openOnboarding(); } catch { /* */ }
  }, [openOnboarding]);

  useEffect(() => { if (open) setIdx(0); }, [open]);

  if (!open) return null;

  const cards = ONBOARDING.cards;
  const card = cards[idx];
  const isLast = idx === cards.length - 1;

  const finish = () => {
    try { localStorage.setItem(ONBOARDING.seenFlag, '1'); } catch { /* */ }
    closeOnboarding();
  };

  const doFinishAction = (action: string) => {
    if (action === 'setStatus:available') { setStatus('available'); finish(); }
    else if (action === 'openSettings') { finish(); openSettings(); }
    else finish();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', zIndex: 1300, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 16 }}>
      <div style={{ width: 'min(520px, 96vw)', background: 'var(--bg-elev-1)', border: '1px solid var(--hairline)', borderRadius: 14, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {/* Kopf */}
        <div style={{ padding: '16px 18px 8px' }}>
          <div style={{ fontSize: 12, letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--tenant-accent)', fontWeight: 700 }}>{ONBOARDING.intro.title}</div>
          <div style={{ color: 'var(--muted)', fontSize: 12.5, marginTop: 4 }}>{ONBOARDING.intro.body}</div>
        </div>

        {/* Karte */}
        <div style={{ padding: '8px 18px 4px', minHeight: 132 }}>
          <div style={{ fontSize: 11, color: 'var(--muted)' }}>Schritt {idx + 1} / {cards.length}</div>
          <h3 style={{ margin: '4px 0 8px', fontSize: 18, color: 'var(--fg)' }}>{card.title}</h3>
          <p style={{ margin: 0, lineHeight: 1.55, color: 'var(--fg-soft)', fontSize: 13.5 }}>{card.body}</p>
          <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
            {'action' in card && card.action === 'openSettings:devices' && (
              <button onClick={() => openSettings('devices')}
                style={btnPrimary}>Jetzt prüfen</button>
            )}
            <button onClick={() => openHelp(card.ctaHelpSlug)} style={btnGhost}>Mehr erfahren →</button>
          </div>
        </div>

        {/* Fortschritt */}
        <div style={{ display: 'flex', gap: 5, justifyContent: 'center', padding: '8px 0' }}>
          {cards.map((_, i) => (
            <span key={i} style={{ width: 6, height: 6, borderRadius: 3, background: i === idx ? 'var(--tenant-accent)' : 'var(--hairline)' }} />
          ))}
        </div>

        {/* Fuß */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 16px', borderTop: '1px solid var(--hairline)' }}>
          <button onClick={finish} style={{ ...btnGhost, marginRight: 'auto' }}>Überspringen</button>
          {idx > 0 && <button onClick={() => setIdx((i) => i - 1)} style={btnGhost}>Zurück</button>}
          {!isLast
            ? <button onClick={() => setIdx((i) => i + 1)} style={btnPrimary}>Weiter</button>
            : ONBOARDING.finish.buttons.map((b) => (
                <button key={b.action} onClick={() => doFinishAction(b.action)}
                  style={b.action === 'setStatus:available' ? btnPrimary : btnGhost}>{b.label}</button>
              ))}
        </div>
      </div>
    </div>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'var(--tenant-accent)', border: '1px solid var(--tenant-accent)', color: '#fff',
  borderRadius: 8, padding: '8px 14px', fontFamily: 'inherit', fontSize: 13, fontWeight: 600, cursor: 'pointer',
};
const btnGhost: React.CSSProperties = {
  background: 'var(--bg-elev-2)', border: '1px solid var(--hairline)', color: 'var(--fg-soft)',
  borderRadius: 8, padding: '8px 12px', fontFamily: 'inherit', fontSize: 13, cursor: 'pointer',
};
